import { useLazyQuery } from '@apollo/client'
import { Button, Collapse, useMediaQuery, useTheme } from '@material-ui/core'
import FilterListIcon from '@material-ui/icons/FilterList'
import Pagination from '@material-ui/lab/Pagination/Pagination'
import { useEffect, useState } from 'react'

import PageHeader from '../../components/PageHeader'
import SectionTitle from '../../components/SectionTitle'
import { COMLOG_QUERY } from '../../graphql/comlog'
import { getTranslate } from '../../localization'
import { ComlogData, ComLogFilters } from '../../types/monitoring'
import MonitoringFilters from './MonitoringFilters'
import MonitoringFormListDesktop from './MonitoringFormList/MonitoringFormListDesktop'
import MonitoringFormListMobile from './MonitoringFormList/MonitoringFormListMobile'
import useStyles from './styles/index.styles'

const RequestsMonitoring = () => {
  const classes = useStyles()
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))
  const [perPage] = useState(8)
  const [filterButtonSelected, setFilterButtonSelected] =
    useState<boolean>(false)
  const [page, setPage] = useState(1)
  const [comlogsFiltersValues, setcomlogsFiltersValues] =
    useState<ComLogFilters>({
      EndpointName: '',
      EndpointURL: '',
      EntityFilters: [],
      From: '',
      page: 1,
      perPage: 8,
      To: ''
    })

  const [getComlogs, { data, refetch }] = useLazyQuery<{
    comLogs: ComlogData
  }>(COMLOG_QUERY, {
    notifyOnNetworkStatusChange: true
  })

  const handleGetComlogs = () => {
    getComlogs({
      variables: { input: { ...comlogsFiltersValues, page, perPage } }
    })
  }

  useEffect(() => {
    handleGetComlogs()
  }, [page, perPage])

  return (
    <div>
      <PageHeader title={getTranslate('Request Monitoring')} />
      <div className={classes.header}>
        <SectionTitle title="Request Monitoring" />
        <Button
          size={isSmallScreen ? 'large' : 'medium'}
          startIcon={<FilterListIcon />}
          variant="contained"
          color="primary"
          onClick={() => setFilterButtonSelected(!filterButtonSelected)}>
          {isSmallScreen ? '' : getTranslate('Filter')}
        </Button>
      </div>
      <Collapse in={filterButtonSelected}>
        <MonitoringFilters
          filters={comlogsFiltersValues}
          setFilters={setcomlogsFiltersValues}
          setPage={setPage}
          handleGetComlogs={handleGetComlogs}
        />
      </Collapse>
      {isSmallScreen ? (
        <MonitoringFormListMobile listData={data?.comLogs.comLogs} />
      ) : (
        <MonitoringFormListDesktop
          listData={data?.comLogs.comLogs}
          refetch={refetch}
        />
      )}
      <div className={classes.paginationContainer}>
        <Pagination
          page={page}
          count={data?.comLogs.pageInfo.lastPage}
          color="primary"
          size={isSmallScreen ? 'small' : 'medium'}
          onChange={(_, value) => setPage(value)}
        />
      </div>
    </div>
  )
}
export default RequestsMonitoring
